import { Box, BoxProps } from '@chakra-ui/react';
import { CSSProperties, ReactNode } from 'react';

import { useInView } from '$hooks/use-in-view';

interface FadeInProps extends Omit<BoxProps, 'children'> {
  children: ReactNode;
  delay?: number;
  as?: BoxProps['as'];
}

export function FadeIn({ children, delay = 0, ...props }: FadeInProps) {
  const [ref, inView] = useInView<HTMLDivElement>();

  const style: CSSProperties = {
    transitionDelay: `${delay}ms`,
  };

  return (
    <Box
      ref={ref}
      className={`fade-in-up${inView ? ' is-visible' : ''}`}
      style={style}
      {...props}
    >
      {children}
    </Box>
  );
}
